import Swiper, { Navigation, Lazy, Pagination } from "swiper";
import Video from "../modules/video";
import Training from "./template-training";

const TemplateSingleService = {
  init() {
    SingleService.events();
    SingleService.fixLineWidth();
    SingleService.videoSlider();
    Video.init();
  },

  events() {
    $(".btn-gallery-type").on("click", (e) =>
      SingleService.handleGalleryType(e.currentTarget)
    );
    $(".btn-training-type").on("click", (e) =>
      Training.handleTrainingType(e.currentTarget)
    );
  },

  fixLineWidth() {
    const btnWidth = this.getButtonWidth($(".btn-gallery-type.active"));
    const line = $(".gallery-types .line");

    line.css({ width: `${btnWidth}px` });
  },

  handleGalleryType(clickedButton) {
    const btn = $(clickedButton);

    if (btn.hasClass("active")) {
      return;
    }

    const line = $(".gallery-types .line");

    $(".btn-gallery-type").each((idx, button) => {
      $(button).removeClass("active");

      if (clickedButton.isEqualNode(button)) {
        $(button).addClass("active");
      }
    });

    const btnWidth = SingleService.getButtonWidth(clickedButton);
    const containerWidth = $(".gallery-types").innerWidth();

    line.css({ width: `${btnWidth}px` });

    if (btn.hasClass("btn-gallery-type--video")) {
      line.css({ transform: `translateX(${containerWidth - btnWidth}px)` });
      $(".news-photo-gallery").addClass("hidden");
      $(".news-video-gallery").removeClass("hidden");
    } else {
      line.css({ transform: "translateX(0px)" });
      $(".news-photo-gallery").removeClass("hidden");
      $(".news-video-gallery").addClass("hidden");

      $(".swiper-wrapper video").each((idx, vid) => {
        vid.pause();
        $(vid).closest(".video").find(".video__overlay").fadeIn(200);
      });
    }
  },

  getButtonWidth(btn) {
    return $(btn).innerWidth();
  },

  videoSlider() {
    const videoEl = $(".news-video-gallery");

    const swiper = new Swiper(videoEl.find(".video-slider")[0], {
      modules: [Lazy, Navigation, Pagination],
      loop: true,
      spaceBetween: 38,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: videoEl.find(".swiper-button-prev")[0],
        nextEl: videoEl.find(".swiper-button-next")[0],
      },
      pagination: {
        el: videoEl.find(".swiper-pagination")[0],
        clickable: true,
        type: "bullets",
      },
    });

    swiper.on("slideChange", () => {
      videoEl.find(".swiper-slide-active video")[0].pause();
      videoEl.find(".video__overlay").fadeIn(200);
    });
  },
};

export default TemplateSingleService;
